import React from 'react';

/**
 * Tool Illustrations Library
 * Animated SVG illustrations for each design tool
 */

// Grid Tool Illustration
export const GridIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <defs>
            <pattern id="demo-grid" width="20" height="20" patternUnits="userSpaceOnUse">
                <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#e2e8f0" strokeWidth="1" />
            </pattern>
            <pattern id="demo-grid-major" width="100" height="100" patternUnits="userSpaceOnUse">
                <path d="M 100 0 L 0 0 0 100" fill="none" stroke="#cbd5e1" strokeWidth="2" />
            </pattern>
        </defs>
        
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Grid */}
        <rect width="300" height="200" fill="url(#demo-grid)" className="animate-pulse" />
        <rect width="300" height="200" fill="url(#demo-grid-major)" className="animate-pulse" />
        
        {/* Sample area */}
        <rect x="50" y="40" width="100" height="80" fill="#8b5cf6" opacity="0.3" rx="4">
            <animate attributeName="opacity" values="0.3;0.5;0.3" dur="2s" repeatCount="indefinite" />
        </rect>
        
        {/* Label */}
        <text x="150" y="190" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Grid helps align elements precisely
        </text>
    </svg>
);

// Rulers Tool Illustration
export const RulersIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Horizontal Ruler */}
        <rect x="0" y="0" width="300" height="20" fill="white" stroke="#94a3b8" strokeWidth="1" />
        {[0, 50, 100, 150, 200, 250].map(x => (
            <g key={x}>
                <line x1={x} y1="0" x2={x} y2="12" stroke="#94a3b8" strokeWidth="1.5" />
                <text x={x} y="18" fontSize="8" fill="#64748b" textAnchor="middle">{x}</text>
            </g>
        ))}
        
        {/* Vertical Ruler */}
        <rect x="0" y="0" width="20" height="200" fill="white" stroke="#94a3b8" strokeWidth="1" />
        {[0, 50, 100, 150].map(y => (
            <g key={y}>
                <line x1="0" y1={y} x2="12" y2={y} stroke="#94a3b8" strokeWidth="1.5" />
                <text x="15" y={y + 3} fontSize="8" fill="#64748b">{y}</text>
            </g>
        ))}
        
        {/* Sample area with measurement */}
        <rect x="80" y="60" width="140" height="80" fill="#8b5cf6" opacity="0.3" rx="4" />
        <line x1="80" y1="50" x2="220" y2="50" stroke="#ef4444" strokeWidth="2" markerEnd="url(#arrowhead)">
            <animate attributeName="stroke-opacity" values="0.5;1;0.5" dur="1.5s" repeatCount="indefinite" />
        </line>
        <text x="150" y="45" fontSize="10" fill="#ef4444" textAnchor="middle" fontWeight="600">140px</text>
        
        <defs>
            <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" fill="#ef4444" />
            </marker>
        </defs>
    </svg>
);

// Alignment Guides Illustration
export const AlignmentGuidesIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Center guides */}
        <line x1="150" y1="0" x2="150" y2="200" stroke="#8b5cf6" strokeWidth="1" strokeDasharray="4 4" opacity="0.5" />
        <line x1="0" y1="100" x2="300" y2="100" stroke="#8b5cf6" strokeWidth="1" strokeDasharray="4 4" opacity="0.5" />
        
        {/* Areas */}
        <rect x="50" y="50" width="80" height="60" fill="#3b82f6" opacity="0.4" rx="4" />
        <rect x="170" y="90" width="80" height="60" fill="#8b5cf6" opacity="0.4" rx="4">
            <animate attributeName="x" values="170;150;170" dur="3s" repeatCount="indefinite" />
        </rect>
        
        {/* Alignment guide appears */}
        <line x1="130" y1="0" x2="130" y2="200" stroke="#8b5cf6" strokeWidth="2" strokeDasharray="6 3">
            <animate attributeName="opacity" values="0;1;0" dur="3s" repeatCount="indefinite" />
        </line>
        <circle cx="130" cy="100" r="4" fill="#8b5cf6">
            <animate attributeName="opacity" values="0;1;0" dur="3s" repeatCount="indefinite" />
        </circle>
        
        {/* Label */}
        <text x="150" y="190" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Guides appear when elements align
        </text>
    </svg>
);

// Area Numbers Toggle Illustration
export const AreaNumbersIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Areas with numbers */}
        <rect x="30" y="30" width="100" height="70" fill="#3b82f6" opacity="0.4" rx="4" />
        <circle cx="80" cy="65" r="18" fill="white" opacity="0.8">
            <animate attributeName="opacity" values="0.8;0;0.8" dur="2s" repeatCount="indefinite" />
        </circle>
        <text x="80" y="72" fontSize="20" fill="#1e40af" textAnchor="middle" fontWeight="bold">
            <animate attributeName="opacity" values="1;0;1" dur="2s" repeatCount="indefinite" />
            1
        </text>
        
        <rect x="170" y="30" width="100" height="70" fill="#8b5cf6" opacity="0.4" rx="4" />
        <circle cx="220" cy="65" r="18" fill="white" opacity="0.8">
            <animate attributeName="opacity" values="0.8;0;0.8" dur="2s" repeatCount="indefinite" />
        </circle>
        <text x="220" y="72" fontSize="20" fill="#6d28d9" textAnchor="middle" fontWeight="bold">
            <animate attributeName="opacity" values="1;0;1" dur="2s" repeatCount="indefinite" />
            2
        </text>
        
        <rect x="30" y="120" width="100" height="60" fill="#10b981" opacity="0.4" rx="4" />
        <circle cx="80" cy="150" r="18" fill="white" opacity="0.8">
            <animate attributeName="opacity" values="0.8;0;0.8" dur="2s" repeatCount="indefinite" />
        </circle>
        <text x="80" y="157" fontSize="20" fill="#047857" textAnchor="middle" fontWeight="bold">
            <animate attributeName="opacity" values="1;0;1" dur="2s" repeatCount="indefinite" />
            3
        </text>
        
        {/* Label */}
        <text x="150" y="195" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Toggle area numbers visibility
        </text>
    </svg>
);

// Timeline Toggle Illustration
export const TimelineIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Area */}
        <rect x="50" y="40" width="200" height="100" fill="#8b5cf6" opacity="0.3" rx="4" />
        
        {/* Timeline bar */}
        <rect x="50" y="35" width="200" height="6" fill="#1e293b" opacity="0.2" rx="3">
            <animate attributeName="opacity" values="0.2;0;0.2" dur="2s" repeatCount="indefinite" />
        </rect>
        <rect x="50" y="35" width="0" height="6" fill="#8b5cf6" rx="3">
            <animate attributeName="width" values="0;200;0" dur="3s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="1;0;1" dur="2s" repeatCount="indefinite" />
        </rect>
        
        {/* Time indicator */}
        <text x="250" y="32" fontSize="10" fill="#64748b" textAnchor="end" fontWeight="600">
            <animate attributeName="opacity" values="1;0;1" dur="2s" repeatCount="indefinite" />
            5s
        </text>
        
        {/* Label */}
        <text x="150" y="180" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Show/hide content duration timeline
        </text>
    </svg>
);

// Outline Mode Illustration
export const OutlineModeIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Before: Area with content */}
        <g>
            <rect x="20" y="30" width="120" height="80" fill="#3b82f6" opacity="0.4" rx="4">
                <animate attributeName="opacity" values="0.4;0;0.4" dur="4s" repeatCount="indefinite" />
            </rect>
            <rect x="30" y="40" width="40" height="30" fill="#1e40af" opacity="0.6" rx="2">
                <animate attributeName="opacity" values="0.6;0;0.6" dur="4s" repeatCount="indefinite" />
            </rect>
            <rect x="80" y="45" width="50" height="5" fill="#1e40af" opacity="0.6" rx="1">
                <animate attributeName="opacity" values="0.6;0;0.6" dur="4s" repeatCount="indefinite" />
            </rect>
            <rect x="80" y="55" width="40" height="5" fill="#1e40af" opacity="0.6" rx="1">
                <animate attributeName="opacity" values="0.6;0;0.6" dur="4s" repeatCount="indefinite" />
            </rect>
            <text x="80" y="25" fontSize="10" fill="#64748b" textAnchor="middle" fontWeight="600">With Content</text>
        </g>
        
        {/* Arrow */}
        <path d="M 145 70 L 155 70" stroke="#64748b" strokeWidth="2" markerEnd="url(#arrow)" />
        
        {/* After: Outline only */}
        <g>
            <rect x="160" y="30" width="120" height="80" fill="none" stroke="#3b82f6" strokeWidth="2" strokeDasharray="4 2" rx="4">
                <animate attributeName="opacity" values="0;1;0" dur="4s" repeatCount="indefinite" />
            </rect>
            <text x="220" y="25" fontSize="10" fill="#64748b" textAnchor="middle" fontWeight="600">Outline Only</text>
        </g>
        
        {/* Label */}
        <text x="150" y="180" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            View areas without content
        </text>
        
        <defs>
            <marker id="arrow" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                <path d="M0,0 L0,6 L9,3 z" fill="#64748b" />
            </marker>
        </defs>
    </svg>
);

// Color Picker Illustration
export const ColorPickerIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Area changing colors */}
        <rect x="80" y="40" width="140" height="100" rx="4">
            <animate attributeName="fill" values="#3b82f6;#8b5cf6;#ec4899;#10b981;#3b82f6" dur="5s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.4;0.6;0.4" dur="2.5s" repeatCount="indefinite" />
        </rect>
        
        {/* Color palette */}
        <g transform="translate(100, 160)">
            {['#3b82f6', '#8b5cf6', '#ec4899', '#10b981', '#f59e0b'].map((color, i) => (
                <circle key={i} cx={i * 20} cy="0" r="8" fill={color}>
                    <animate attributeName="r" values="8;10;8" dur="2s" begin={`${i * 0.4}s`} repeatCount="indefinite" />
                </circle>
            ))}
        </g>
        
        {/* Label */}
        <text x="150" y="190" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Customize area colors
        </text>
    </svg>
);

// Safe Zones Illustration
export const SafeZonesIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Full area */}
        <rect x="30" y="30" width="240" height="140" fill="#e2e8f0" opacity="0.3" rx="4" />
        
        {/* Safe zone */}
        <rect x="45" y="45" width="210" height="110" fill="none" stroke="#ef4444" strokeWidth="2" strokeDasharray="8 4" rx="4">
            <animate attributeName="stroke-opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite" />
        </rect>
        
        {/* Corner markers */}
        {[[45, 45], [255, 45], [45, 155], [255, 155]].map(([x, y], i) => (
            <g key={i}>
                <circle cx={x} cy={y} r="6" fill="#ef4444">
                    <animate attributeName="r" values="6;8;6" dur="2s" repeatCount="indefinite" />
                </circle>
                <circle cx={x} cy={y} r="3" fill="white" />
            </g>
        ))}
        
        {/* Label */}
        <text x="150" y="25" fontSize="11" fill="#ef4444" textAnchor="middle" fontWeight="600">Safe Zone (5%)</text>
        <text x="150" y="190" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Prevent content cutoff
        </text>
    </svg>
);

// Snap to Grid Illustration
export const SnapToGridIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <defs>
            <pattern id="snap-grid" width="20" height="20" patternUnits="userSpaceOnUse">
                <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#e2e8f0" strokeWidth="1" />
            </pattern>
        </defs>
        
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        <rect width="300" height="200" fill="url(#snap-grid)" opacity="0.5" />
        
        {/* Moving area that snaps */}
        <rect x="60" y="60" width="80" height="60" fill="#8b5cf6" opacity="0.4" rx="4">
            <animate attributeName="x" values="60;100;100;140;140" dur="4s" repeatCount="indefinite" />
            <animate attributeName="y" values="60;60;80;80;100" dur="4s" repeatCount="indefinite" />
        </rect>
        
        {/* Snap indicator */}
        <circle cx="100" cy="80" r="6" fill="#10b981" opacity="0">
            <animate attributeName="opacity" values="0;1;0;0;0" dur="4s" repeatCount="indefinite" />
            <animate attributeName="r" values="6;10;6;6;6" dur="4s" repeatCount="indefinite" />
        </circle>
        
        {/* Label */}
        <text x="150" y="190" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Elements snap to grid points
        </text>
    </svg>
);

// Background Pattern Illustration
export const BackgroundPatternIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        {/* Background */}
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Three pattern examples */}
        {/* Dots Pattern */}
        <g>
            <defs>
                <pattern id="dots-demo" width="10" height="10" patternUnits="userSpaceOnUse">
                    <circle cx="5" cy="5" r="1.5" fill="#94a3b8" />
                </pattern>
            </defs>
            <rect x="20" y="40" width="70" height="50" fill="url(#dots-demo)" opacity="0.4" rx="4" />
            <text x="55" y="100" fontSize="9" fill="#64748b" textAnchor="middle" fontWeight="600">Dots</text>
        </g>

        {/* Grid Pattern */}
        <g>
            <defs>
                <pattern id="grid-demo" width="10" height="10" patternUnits="userSpaceOnUse">
                    <path d="M 10 0 L 0 0 0 10" fill="none" stroke="#94a3b8" strokeWidth="0.5" />
                </pattern>
            </defs>
            <rect x="115" y="40" width="70" height="50" fill="url(#grid-demo)" opacity="0.4" rx="4" />
            <text x="150" y="100" fontSize="9" fill="#64748b" textAnchor="middle" fontWeight="600">Grid</text>
        </g>

        {/* Diagonal Lines Pattern */}
        <g>
            <defs>
                <pattern id="lines-demo" width="10" height="10" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                    <line x1="0" y1="0" x2="0" y2="10" stroke="#94a3b8" strokeWidth="1" />
                </pattern>
            </defs>
            <rect x="210" y="40" width="70" height="50" fill="url(#lines-demo)" opacity="0.4" rx="4" />
            <text x="245" y="100" fontSize="9" fill="#64748b" textAnchor="middle" fontWeight="600">Lines</text>
        </g>

        {/* Canvas with pattern */}
        <rect x="50" y="120" width="200" height="60" fill="url(#dots-demo)" opacity="0.2" rx="4" stroke="#cbd5e1" strokeWidth="2">
            <animate attributeName="opacity" values="0.2;0.4;0.2" dur="3s" repeatCount="indefinite" />
        </rect>
        
        {/* Label */}
        <text x="150" y="195" fontSize="12" fill="#64748b" textAnchor="middle" fontWeight="600">
            Add visual patterns to canvas background
        </text>
    </svg>
);

// Crosshair Illustration
export const CrosshairIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <rect width="300" height="200" fill="#f8fafc" />
        {/* Content blocks */}
        <rect x="50" y="40" width="80" height="60" fill="#e2e8f0" rx="4" />
        <rect x="170" y="40" width="80" height="60" fill="#e2e8f0" rx="4" />
        <rect x="50" y="120" width="200" height="50" fill="#e2e8f0" rx="4" />
        
        {/* Crosshair lines with animation */}
        <line x1="0" y1="70" x2="300" y2="70" stroke="#ef4444" strokeWidth="1" strokeDasharray="4 2">
            <animate attributeName="y1" values="50;150;50" dur="4s" repeatCount="indefinite" />
            <animate attributeName="y2" values="50;150;50" dur="4s" repeatCount="indefinite" />
        </line>
        <line x1="90" y1="0" x2="90" y2="200" stroke="#ef4444" strokeWidth="1" strokeDasharray="4 2">
            <animate attributeName="x1" values="50;250;50" dur="5s" repeatCount="indefinite" />
            <animate attributeName="x2" values="50;250;50" dur="5s" repeatCount="indefinite" />
        </line>
        
        {/* Cursor */}
        <circle cx="90" cy="70" r="3" fill="#ef4444" stroke="white" strokeWidth="1">
            <animate attributeName="cy" values="50;150;50" dur="4s" repeatCount="indefinite" />
            <animate attributeName="cx" values="50;250;50" dur="5s" repeatCount="indefinite" />
        </circle>
        
        {/* Coordinates label */}
        <g>
            <rect x="100" y="80" width="60" height="20" fill="#1e293b" rx="4" opacity="0.9">
                 <animate attributeName="y" values="60;160;60" dur="4s" repeatCount="indefinite" />
                 <animate attributeName="x" values="60;260;60" dur="5s" repeatCount="indefinite" />
            </rect>
            <text x="130" y="94" fontSize="10" fill="white" textAnchor="middle" fontFamily="monospace">
                X:120 Y:85
                 <animate attributeName="y" values="74;174;74" dur="4s" repeatCount="indefinite" />
                 <animate attributeName="x" values="90;290;90" dur="5s" repeatCount="indefinite" />
            </text>
        </g>
    </svg>
);

// Focus Mode Illustration
export const FocusModeIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Dimmed Background Areas */}
        <g opacity="0.3">
            <rect x="20" y="20" width="80" height="60" fill="#64748b" rx="4" />
            <rect x="110" y="20" width="170" height="60" fill="#64748b" rx="4" />
            <rect x="20" y="90" width="60" height="90" fill="#64748b" rx="4" />
        </g>

        {/* Focused Area */}
        <g>
            <rect x="90" y="90" width="190" height="90" fill="#3b82f6" rx="4" filter="drop-shadow(0 10px 15px rgb(0 0 0 / 0.1))"/>
            <text x="185" y="140" fontSize="14" fill="white" textAnchor="middle" fontWeight="bold">Active Area</text>
        </g>
        
        {/* Focus indicator */}
        <path d="M 80 80 L 100 80 L 100 85 L 85 85 L 85 100 L 80 100 Z" fill="#3b82f6" />
        <path d="M 290 80 L 270 80 L 270 85 L 285 85 L 285 100 L 290 100 Z" fill="#3b82f6" />
        <path d="M 80 190 L 100 190 L 100 185 L 85 185 L 85 170 L 80 170 Z" fill="#3b82f6" />
        <path d="M 290 190 L 270 190 L 270 185 L 285 185 L 285 170 L 290 170 Z" fill="#3b82f6" />
    </svg>
);

// Magnet Illustration
export const MagnetIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Fixed Object */}
        <rect x="50" y="50" width="80" height="100" fill="#e2e8f0" stroke="#cbd5e1" strokeWidth="2" rx="4" />
        
        {/* Moving Object snapping to fixed object */}
        <g>
            <rect x="135" y="50" width="100" height="60" fill="#818cf8" rx="4" opacity="0.9">
                <animate attributeName="x" values="160;130;130;160" dur="3s" repeatCount="indefinite" />
            </rect>
            
            {/* Magnetic force visual */}
            <path d="M 130 80 L 110 80" stroke="#6366f1" strokeWidth="2" strokeDasharray="4 2" opacity="0">
                <animate attributeName="opacity" values="0;1;1;0" dur="3s" repeatCount="indefinite" />
                <animate attributeName="d" values="M 145 80 L 130 80; M 130 80 L 130 80; M 130 80 L 130 80; M 145 80 L 130 80" dur="3s" repeatCount="indefinite" />
            </path>
            
            {/* Snap Indicator */}
            <circle cx="130" cy="50" r="4" fill="#ef4444" opacity="0">
                <animate attributeName="opacity" values="0;1;1;0" dur="3s" repeatCount="indefinite" />
            </circle>
            <circle cx="130" cy="110" r="4" fill="#ef4444" opacity="0">
                <animate attributeName="opacity" values="0;1;1;0" dur="3s" repeatCount="indefinite" />
            </circle>
        </g>
    </svg>
);

// Grayscale Illustration
export const GrayscaleIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <defs>
            <filter id="grayscale-filter">
                <feColorMatrix type="matrix" values="0.33 0.33 0.33 0 0
                                                   0.33 0.33 0.33 0 0
                                                   0.33 0.33 0.33 0 0
                                                   0 0 0 1 0" />
            </filter>
        </defs>
        
        {/* Slit view: Left Color, Right Grayscale */}
        <g>
            {/* Colored Side */}
            <rect x="0" y="0" width="150" height="200" fill="#f8fafc" />
            <circle cx="75" cy="60" r="30" fill="#ef4444" />
            <rect x="35" y="110" width="80" height="60" fill="#3b82f6" />
            <text x="75" y="190" fontSize="12" fill="#334155" textAnchor="middle">Color Mode</text>
        </g>
        
        <g filter="url(#grayscale-filter)">
            {/* Grayscale Side */}
            <rect x="150" y="0" width="150" height="200" fill="#f8fafc" />
            <circle cx="225" cy="60" r="30" fill="#ef4444" />
            <rect x="185" y="110" width="80" height="60" fill="#3b82f6" />
            <text x="225" y="190" fontSize="12" fill="#334155" textAnchor="middle">Grayscale</text>
        </g>
        
        {/* Divider */}
        <line x1="150" y1="0" x2="150" y2="200" stroke="#94a3b8" strokeWidth="2" strokeDasharray="5 5" />
        <circle cx="150" cy="100" r="15" fill="white" stroke="#94a3b8" strokeWidth="2" />
        <path d="M 145 100 L 140 100 M 155 100 L 160 100" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

// Area Borders Illustration
export const AreaBordersIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Solid Border Example */}
        <g>
            <rect x="30" y="40" width="70" height="60" fill="white" stroke="#3b82f6" strokeWidth="2" rx="4" />
            <text x="65" y="115" fontSize="10" fill="#64748b" textAnchor="middle">Solid</text>
        </g>

        {/* Dashed Border Example */}
        <g>
            <rect x="115" y="40" width="70" height="60" fill="white" stroke="#3b82f6" strokeWidth="2" strokeDasharray="6 4" rx="4" />
            <text x="150" y="115" fontSize="10" fill="#64748b" textAnchor="middle">Dashed</text>
        </g>

        {/* Dotted Border Example */}
        <g>
            <rect x="200" y="40" width="70" height="60" fill="white" stroke="#3b82f6" strokeWidth="2" strokeDasharray="2 4" strokeLinecap="round" rx="4" />
            <text x="235" y="115" fontSize="10" fill="#64748b" textAnchor="middle">Dotted</text>
        </g>

        {/* Width Animation */}
        <g>
            <rect x="50" y="140" width="200" height="30" fill="#e0e7ff" rx="4" />
            <line x1="70" y1="155" x2="230" y2="155" stroke="#4f46e5" strokeWidth="2">
                <animate attributeName="strokeWidth" values="1;6;1" dur="3s" repeatCount="indefinite" />
            </line>
        </g>
    </svg>
);

// Resize Handles Illustration
export const ResizeHandlesIllustration = () => (
    <svg viewBox="0 0 300 200" className="w-full h-auto">
        <rect width="300" height="200" fill="#f8fafc" />
        
        {/* Selected Area */}
        <g>
            <rect x="80" y="60" width="140" height="80" fill="white" stroke="#3b82f6" strokeWidth="1" />
            
            {/* Corner Handles */}
            <rect x="76" y="56" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
            <rect x="216" y="56" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
            <rect x="76" y="136" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
            <rect x="216" y="136" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
            
            {/* Side Handles */}
            <rect x="146" y="56" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
            <rect x="146" y="136" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
            <rect x="76" y="96" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
            <rect x="216" y="96" width="8" height="8" fill="white" stroke="#3b82f6" strokeWidth="1" />
        </g>

        {/* Animation Cursor */}
        <circle cx="220" cy="140" r="4" fill="#64748b" opacity="0.5">
            <animate attributeName="r" values="4;20;4" dur="2s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.5;0;0.5" dur="2s" repeatCount="indefinite" />
        </circle>
    </svg>
);

// Export all illustrations
const ToolIllustrations = {
    grid: GridIllustration,
    rulers: RulersIllustration,
    alignmentGuides: AlignmentGuidesIllustration,
    areaNumbers: AreaNumbersIllustration,
    timeline: TimelineIllustration,
    outlineMode: OutlineModeIllustration,
    colorPicker: ColorPickerIllustration,
    safeZones: SafeZonesIllustration,
    snapToGrid: SnapToGridIllustration,
    backgroundPattern: BackgroundPatternIllustration,
    crosshair: CrosshairIllustration,
    focusMode: FocusModeIllustration,
    magnet: MagnetIllustration,
    grayscale: GrayscaleIllustration,
    areaBorder: AreaBordersIllustration,
    resizeHandles: ResizeHandlesIllustration
};

export default ToolIllustrations;
